module.exports = __webpack_public_path__ + "img/checkmark.513be18c.svg";